import styled from "styled-components";
import { Space, Button as AntButton } from "antd";
import { IMG_WHEEL_BG, IMG_SPIN_BG, RefreshOutlined } from "@assets";

export const RootContainer = styled.div`
	position: relative;
	height: 100vh;
	overflow: hidden;

	background-image: url(${IMG_SPIN_BG});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: top;
`;
export const RefreshIcon = styled(RefreshOutlined)`
	font-size: 24px;
	color: #fff;
`;

export const DailyWinnerListContainer = styled.div`
	margin: 291px 0 0 0;
	flex-direction: column;
	align-items: center;

	@media screen and (min-width: 400px) {
		margin: 298px 0 0 0;
	}
`;

export const EmptyTextWrapper = styled.div`
	height: calc(100% - 26px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;

	@media screen and (max-height: 650px) {
		height: calc(100% - 26px);
	}
`;

export const Title = styled.div`
	text-align: center;
	color: #fff;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: 1.5;

	@media (min-height: 735px) and (max-height: 745px) {
		margin-bottom: 0px;
	}
`;

export const Number = styled.div`
	padding-right: 4px;
	color: #fff;
	text-align: right;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;

	@media screen and (max-height: 670px) {
		font-size: 12px;
	}
`;

export const Bottom = styled(Space)`
	padding-top: 305px;
	padding-bottom: 16px;
	z-index: 99;
	background-color: ${(props) => props.theme.backgroundColor};
	position: fixed;
	width: 100%;
	max-width: 480px;
	gap: 16px !important;
	justify-content: center;

	.ant-space-item {
		flex: 1;

		:nth-child(1) {
			text-align: right;
			padding-inline-start: 16px;
		}

		:nth-child(2) {
			text-align: left;
			padding-inline-end: 16px;
		}
	}

	.ant-btn {
		width: 100%;
		background-color: #71207c !important;
	}

	@media screen and (max-width: 400px) {
		padding-top: 285px;
	}
`;

export const SpinnerBox = styled.div`
	width: 100%;
	position: sticky;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
`;

export const OuterBadge = styled.img.attrs({
	alt: "badge",
	id: "badge-img",
	src: IMG_WHEEL_BG,
})`
	position: absolute;
	width: 253px;
	height: 253px;
	cursor: pointer;
	z-index: 200;
	top: 20px;
	margin-left: 0px;

	@media screen and (max-width: 350px) {
		width: 210px;
		height: 210px;
		margin-left: 0px;
		top: 20px;
	}
	@media screen and (max-height: 650px) {
		width: 220px;
		height: 220px;
		top: 10px;
	}
	@media screen and (max-height: 582px) {
		width: 185px;
		height: 185px;
		top: 5px;
	}
`;

export const WheelContainer = styled.div`
	width: 100%;
	max-width: 480px;
	height: 293px;
	z-index: 800;
	display: flex;
	align-items: center;
	justify-content: center;

	> div {
		width: 250px;
		height: 250px;
		transform: rotate(-53deg);
		background: radial-gradient(1.24% 50% at 50% 50%, #00DE00 0%, #AF9B00 33.33%, #AD5B09 100%);
		border-radius: 50%;
	}

	img:not(#badge-img):not(#center) {
		display: none;
	}

	@media screen and (max-width: 350px) {
		height: 250px;

		> div {
			width: 207px;
			height: 207px;
		}
	}

	@media screen and (max-height: 650px) {
		> div {
			width: 217px;
			height: 217px;
			top: 10px;
		}
		height: 220px;
	}

	@media screen and (max-height: 582px) {
		> div {
			width: 182px;
			height: 182px;
			top: 0;
		}
		height: 195px;
	}
`;

export const Container = styled.div`
	position: relative;
	z-index: 999;
	text-align: center;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.ant-btn {
		width: 100%;
		height: 52px;
		margin-top: 24px;
		max-width: 170px;
	}
`;

export const Text = styled.div`
	padding-bottom: 10px;
	color: #ECAA00;
	font-size: 18px;
`;

export const SpinWrapper = styled.div`
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	position: relative;
`;

export const WinnersContainer = styled.div`
	height: calc(100% - 17px);
	position: relative;
	overflow-y: auto;
`;

export const WinnerItem = styled.div`
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	align-items: flex-start;
	gap: 8px;

	padding: 5px 0;
	margin-bottom: 1px;

	:first-child {
		margin-top: 6px;
	}

`;

export const LeftSection = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
`;

export const PhNameWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 3;
`;

export const NameWrapper = styled.div`
	color: #fff;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5; 
	text-align: left;

	word-break: break-all;

	@media screen and (max-height: 670px) {
		font-size: 12px;
	}
`;

export const PhoneWrapper = styled.div`
	color: #fff;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5; 
	@media screen and (max-height: 670px) {
		font-size: 12px;
	}
`;

export const AmountWrapper = styled.div`
	color: #FB0;
	font-size: 14px;
	font-weight: 700;
	line-height: 1.5;
	@media screen and (max-height: 670px) {
		font-size: 12px;
	}
`;

export const BottomContainer = styled.div`
	display: flex;
	/* position: relative; */
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	z-index: 1000;

	@media screen and (max-height: 650px) {
		margin-top: 16px;
	}
	@media screen and (max-height: 582px) {
		margin-top: 0;
	}
`;

export const TableContainer = styled.div`
	height: calc(100vh - 70px - 235px - 55px - 110px - 22px);
	width: calc(100% - 32px);
	z-index: 99;
	padding: 16px;
	margin-top: 14px;
	box-sizing: border-box;

	border-radius: 20px;
	background: rgba(0, 0, 0, 0.50);
	backdrop-filter: blur(25px);

	overflow: hidden;

	@media screen and (max-height: 650px) {
		height: calc(100vh - 70px - 180px - 55px - 110px - 22px);
		padding: 6px 12px;
	} 

	@media screen and (max-height: 582px) {
		height: calc(100vh - 70px - 180px - 55px - 85px);
	}
`;

export const WinnerTitle = styled.div`
	color: #FB0;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;

	@media screen and (max-height: 650px) {
		font-size: 15px;
	}
`

export const ButtonWrapper = styled.div`
	max-width: calc(100% - 32px);
	height: 49.25px;
	display: flex;
	gap: 12px;
	justify-content: space-between;
	padding: 5px 0;
	margin: 0 16px;
	position: absolute;
	bottom: 0;
	width: 100%;

	@media screen and (max-height: 650px) {
		height: 53px;
	}
	
	@media screen and (max-height: 582px) {
		bottom: 0px;
	}
`;

export const ButtonDiv = styled.div`
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	gap: 8px;

	border-radius: 16px;
	background: ${props => props.isRule === 1 ? 'linear-gradient(180deg, #F9B200 0%, #EC7601 100%)' : 'linear-gradient(180deg, #F00F11 0%, #CC0D0E 36%)'};
	box-shadow: 0px 7px 10px 0px rgba(255, 255, 255, 0.25) inset;


	color: #fff;
	text-align: center;
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	line-height: 26px; /* 162.5% */
`;

export const LoadMoreWrapper = styled.div`
	text-decoration: underline;
	color: #d28a28;
	font-size: 14px;
	font-weight: 100;
	line-height: 17.5px;
	cursor: pointer;
	margin: 10px 0;
`;

export const StartButton = styled(AntButton)`
	display: flex;
	align-items: center;
	justify-content: center;
	width: calc(100% - 32px);
	height: 55px;
	border-radius: 16px !important;
	border: 2px solid #FFF !important;
`;

export const CenterIcon = styled.img.attrs((props) => ({
	id: props.id,
	src: props.src,
}))`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 1000;
	width: 50px;
	height: 50px;

	@media screen and (max-width: 325px) {
		width: 40px;
		height: 40px;
	}
`;
